
<template>
    <div class="dottedBox">
      <div class="dottedTitle c324 pl20 fz16">
        {{dotedName}}
      </div>
      <slot></slot>
    </div>
</template>

<script>

    export default {
        props: ['dotedName'],
        data() {
            return {
              tagsList: [],
              childSelect:''
            }
        },
        methods: {
          selectRow () {
            console.log('xxx')
          }
        },
        watch:{

        },
        mounted () {
        }
    }

</script>


<style lang='scss'>
  .dottedBox{
    width: 100%;border: 1px dashed #324170;border-radius: 10px;
    .dottedTitle{
      border-bottom: 1px dashed #324170;height: 50px;line-height: 50px;
    }
  }
</style>
